/* SkinVibe — Country/Language selector closing animation (mobile)
   1:1 with Shopify account modal: adds .skinvibe-closing class,
   waits for animationend, then calls original hidePanel().
   Loaded when custom_country_modal = true in header-drawer.liquid.
*/
(function () {
  'use strict';
  var CLS = 'skinvibe-closing';

  customElements.whenDefined('localization-form').then(function () {
    var Ctor = customElements.get('localization-form');
    if (!Ctor || Ctor.prototype._svPatched) return;
    Ctor.prototype._svPatched = true;

    var origHide = Ctor.prototype.hidePanel;
    var busy = false;

    function animatedHide(form) {
      if (window.innerWidth > 749) return origHide.call(form);

      var panel = form.elements && form.elements.panel;
      if (!panel || panel.hasAttribute('hidden') || busy) return;

      busy = true;
      var overlay = panel.parentElement
        ? panel.parentElement.querySelector('.country-selector__overlay, .language-selector__overlay')
        : null;

      panel.classList.add(CLS);
      if (overlay) overlay.classList.add(CLS);

      function done() {
        panel.removeEventListener('animationend', onEnd);
        panel.classList.remove(CLS);
        if (overlay) overlay.classList.remove(CLS);
        busy = false;
        origHide.call(form);
      }

      function onEnd(e) {
        if (e.target === panel) done();
      }

      panel.addEventListener('animationend', onEnd);
      setTimeout(function () { if (busy) done(); }, 300);
    }

    Ctor.prototype.hidePanel = function () { animatedHide(this); };

    document.querySelectorAll('localization-form').forEach(function (form) {
      var closeBtn = form.elements && form.elements.closeButton
        || form.querySelector('.language-selector__close-button');
      if (!closeBtn) return;
      closeBtn.addEventListener('click', function (e) {
        if (window.innerWidth > 749) return;
        e.stopImmediatePropagation();
        animatedHide(form);
      }, true);
    });
  });
})();
